<template>
  <div>
    <lite-dashboard v-if="isLiteSubscriber" />
    <main-dashboard v-else-if="useOld" />
    <next-dashboard v-else />
  </div>
</template>

<script>
import MainDashboard from '@/components/CancelAnalytics/MainDashboard.vue';
import NextDashboard from '@/components/CancelAnalytics/NextDashboard.vue';
import LiteDashboard from '@/components/CancelAnalytics/LiteDashboard.vue';

export default {
  name: 'CancellationAnalytics',
  components: {
    NextDashboard,
    MainDashboard,
    LiteDashboard,
  },
  computed: {
    useNext() {
      return this.$route.query.next;
    },
    useOld() {
      return this.$route.query.old;
    },
    user() {
      return this.$store.state.user;
    },
    isLiteSubscriber() {
      return this.$store.getters.isLiteSubscriber;
    },
  },
};
</script>
